import { S as ScrollBoundaryTools } from './scrollBoundaryTools-4fc80d69.js';

class ScrollUtils {
}
ScrollUtils.boundary = ScrollBoundaryTools;

export { ScrollUtils as S };
//# sourceMappingURL=scrollUtils-924b3ce4.js.map
